/* eslint-disable @typescript-eslint/no-explicit-any */
import ApiService from '@/core/services/ApiService';
import { Actions, Mutations } from '@/store/enums/StoreEnums';
import router from '@/router';
import { Module, Action, Mutation, VuexModule } from 'vuex-module-decorators';
import { getMapping } from '@/core/config/viewMapping/GeneralListMapping';

import { Utils } from '@/core/helpers/Utils';
import Messages from '@/core/helpers/Messages';

@Module
export default class DynamicListModule extends VuexModule {
	dynamicList = {} as any;
	mapping = {} as any;

	searchTerm = {};
	parentID = {};
	modalRoute = {};
	sortBy = {} as any;
	inlineSearch = {};
	sortableListChanged = {};
	isModalOpen = {};



	@Action({ rawError: true })
	async [Actions.SETUP_LIST](payload) {
		if (!payload.dontClearBeforeSetup) {
			this.context.commit(Mutations.CLEAR_LIST_MODULE)
			this.context.dispatch(Actions.CLEAR_FILTER_MODULE)
		}
		this.context.commit(Mutations.SET_SORTABLE_LIST_CHANGED, { key: payload.key, flag: false })
		this.context.commit(Mutations.SET_DYNAMIC_LIST, { key: payload.key, list: [] });
		this.context.dispatch(Actions.RESET_PAGINATION_PARAMS, { key: payload.key });
		const mapping = await getMapping(payload.key);
		if (!mapping?.map) {
		console.error(`No mapping found for key ${payload.key}`);
		return;
		}

		await this.context.commit(Mutations.SET_MAPPING, { key: payload.key, mapping: mapping });



		if (this.mapping[payload.key].map.InlineSearch) {
			this.context.commit(Mutations.SET_INLINE_SEARCH, { key: payload.key });
		}

		if (payload.parentID || payload.parentID == 0) {

			this.context.commit(Mutations.SET_PARENT_ID, { key: payload.key, parentID: payload.parentID });
		}
		else {
			this.context.commit(Mutations.SET_PARENT_ID, { key: payload.key, parentID: 0 });
		}

		await this.context.dispatch(Actions.INITIALIZE_FILTER_VALUES, { key: payload.key, isResetFilters: false });
		const queryParams = router.currentRoute.value.query;

		if (queryParams['SearchTerm']) {
			this.context.commit(Mutations.SET_SEARCH_TERM, { key: payload.key, searchTerm: queryParams['SearchTerm'] });
		}
		await this.context.dispatch(Actions.GET_DYNAMIC_LIST, { key: payload.key, page: (queryParams['pageNumber']) ? queryParams['pageNumber'] : 1 });

	}
	@Action({ rawError: true })
	[Actions.SET_MAPPING](payload) {
		this.context.commit(Mutations.SET_MAPPING, { key: payload.key, mapping: payload.mapping });
	}
	@Action({ rawError: true })
	[Actions.SET_PARENT_ID](payload) {
		this.context.commit(Mutations.SET_PARENT_ID, { key: payload.key, parentID: payload.parentID });
	}

	@Action({ rawError: true })
	[Actions.SET_SEARCH_TERM](payload) {
		this.context.commit(Mutations.SET_SEARCH_TERM, { key: payload.key, searchTerm: payload.searchTerm });
	}
	@Action({ rawError: true })
	[Actions.SET_SORT_BY](payload) {
		this.context.commit(Mutations.SET_SORT_BY, { key: payload.key, sortBy: payload.sortBy });
	}

	@Action({ rawError: true })
	async [Actions.DELETE_ITEM](payload) {

		await ApiService.delete(this.mapping[payload.key].deleteEndpoint + "/" + payload.id);


		await this.context.dispatch(Actions.GET_DYNAMIC_LIST, { key: payload.key, page: this.context.rootState.PaginationModule.paginationParams[payload.key].currentPage })
		this.context.rootState.PaginationModule.paginationParams.currentPage
	}
	@Action({ rawError: true })
	async [Actions.DISABLE_ITEM](payload) {

		await ApiService.delete(this.mapping[payload.key].disableEndpoint + "/" + payload.id);


		await this.context.dispatch(Actions.GET_DYNAMIC_LIST, { key: payload.key, page: this.context.rootState.PaginationModule.paginationParams[payload.key].currentPage })
		this.context.rootState.PaginationModule.paginationParams.currentPage
	}
	@Action({ rawError: true })
	async [Actions.GET_DYNAMIC_LIST](payload) {
		if (this.mapping) {

			const params = Utils.buildListParams(payload.key, payload.page)

			const response = await ApiService.get(this.mapping[payload.key].endpoint, '', params, payload.key);

			this.context.commit(Mutations.SET_DYNAMIC_LIST, { list: response.data, key: payload.key });


		}
	}
	@Action({ rawError: true })
	async [Actions.SET_DYNAMIC_LIST](payload) {
		this.context.commit(Mutations.SET_SORTABLE_LIST_CHANGED, { key: payload.key, flag: true })
		this.context.commit(Mutations.SET_DYNAMIC_LIST, payload)
	}
	@Action({ rawError: true })
	async [Actions.SET_LIST_ORDER](payload) {
		
		const list: any[] = this.dynamicList[payload.key] || [];
		const map = this.mapping[payload.key]?.map;
		const primaryKey = map?.PrimaryKey || 'id';
		const useIdsOnly = map?.UpdateOrderUseIds === true;
		const method = (map?.UpdateOrderMethod || 'PATCH').toUpperCase();
		const body = useIdsOnly ? list.map((item) => item[primaryKey]) : list;
		
		if (method === 'POST') {
			await ApiService.post(this.mapping[payload.key].updateOrderEndpoint, body as any);
		} else if (method === 'PUT') {
			await (ApiService as any).put?.(this.mapping[payload.key].updateOrderEndpoint, body as any);
		} else {
			await ApiService.patch(this.mapping[payload.key].updateOrderEndpoint, body as any);
		}
		this.context.commit(Mutations.SET_SORTABLE_LIST_CHANGED, { key: payload.key, flag: false })
		if (Object.keys(this.context.rootState.ErrorModule.errors).length == 0) {
		
			Messages.showSuccess("Order changed successfully");
		}
	}

	@Action({ rawError: true })
	async [Actions.CALL_CUSTOM_API](payload: { key: string; handlerName: string; row: any }) {
		const { key, handlerName, row } = payload;
		const map = this.mapping[key]?.map;
		if (!map) return;

		const allButtons = [
			...(map.FooterButtons ?? []),
			...(map.HeaderButtons ?? []),
			...(map.RowButtons ?? []),
		];
		const btn = allButtons.find((b: any) => b.onClick === handlerName);
		const api = btn?.api;
		if (!api) return;

		const urlBase = typeof api.endpoint === "function" ? api.endpoint(row) : api.endpoint;
		const params = typeof api.params === "function" ? api.params(row, { rootState: this.context.rootState }) : (api.params ?? {});
		const body = typeof api.body === "function" ? api.body(row, { rootState: this.context.rootState }) : api.body;

		const method = (api.method ?? "GET").toUpperCase();

		// helper to append query when ApiService method doesn’t accept params
		const buildUrlWithQuery = (url: string, q: Record<string, any> | undefined) => {
			if (!q || Object.keys(q).length === 0) return url;
			const qs = new URLSearchParams(q as any).toString();
			return `${url}${url.includes("?") ? "&" : "?"}${qs}`;
		};

		try {
			switch (method) {
				case "GET":
					// Option A: your ApiService.get accepts params as 3rd arg → use it and DO NOT pass the 4th arg
					await ApiService.get(urlBase, "", params /*, undefined */);
					// If your get() doesn’t accept params, use:
					// await ApiService.get(buildUrlWithQuery(urlBase, params), "");
					break;

				case "DELETE":
					// Most delete() signatures don’t take params → append to URL
					await ApiService.delete(buildUrlWithQuery(urlBase, params));
					break;

				case "POST":
					await ApiService.post(urlBase, body, params);
					break;

				case "PATCH":
					await ApiService.patch(urlBase, body, params);
					break;

				case "PUT":
					// only if you have put()
					await (ApiService as any).put?.(urlBase, body, params);
					break;

				default:
					throw new Error(`Unsupported method: ${method}`);
			}

			if (api.successMessage) {
				Messages.showSuccess(api.successMessage);
			}
			if (api.refreshList) {
				const current = this.context.rootState.PaginationModule.paginationParams[key]?.currentPage ?? 1;
				await this.context.dispatch(Actions.GET_DYNAMIC_LIST, { key, page: current });
			}
		} catch (err: any) {
			Messages.showError(err?.response?.data?.message ?? "Request failed.");
		}
	}


	@Mutation
	[Mutations.SET_SORTABLE_LIST_CHANGED](payload) {
		this.sortableListChanged[payload.key] = payload.flag;
	}
	@Mutation
	[Mutations.SET_DYNAMIC_LIST](payload) {
		this.dynamicList[payload.key] = payload.list;
	}
	@Mutation
	[Mutations.SET_MAPPING](payload) {
		this.mapping[payload.key] = payload.mapping;
		if (payload.mapping) {
			if (payload.mapping.map.DefaultSorting) {
				this.sortBy[payload.key] = {
					sortColumn: payload.mapping.map.DefaultSorting,
					sortType: payload.mapping.map.DefaultSortingType,
				};

			}
		}
	}
	@Mutation
	[Mutations.SET_SEARCH_TERM](payload) {
		this.searchTerm[payload.key] = payload.searchTerm;
	}
	@Mutation
	[Mutations.SET_SORT_BY](payload) {
		this.sortBy[payload.key] = payload.sortBy;
	}
	@Mutation
	[Mutations.SET_PARENT_ID](payload) {
		this.parentID[payload.key] = payload.parentID;

		this.modalRoute[payload.key] = this.mapping[payload.key].map.Actions.addLink;
	}


	@Mutation
	[Mutations.SET_INLINE_SEARCH](payload) {

		this.inlineSearch[payload.key] = true;
	}
	@Mutation
	[Mutations.CLEAR_LIST_MODULE]() {

		this.dynamicList = {} as any;
		this.mapping = {} as any;
		this.searchTerm = {};
		this.parentID = {};
		this.modalRoute = {};
		this.sortBy = {} as any;
		this.inlineSearch = {};
		this.sortableListChanged = {};
		this.isModalOpen = {};
	}


	/**
	 * Get dynamic list object
	 *
	 */
	get getDynamicList() {
		return (payload) => {
			return this.dynamicList[payload.key];
		}
	}
	/**
	 * Get mapping object
	 * @returns Mapping
	 */
	get getMapping() {
		return (payload) => {



			return this.mapping[payload.key];
		}
	}
	/**
	 * Get mapping object
	 * @returns Mapping
	 */
	get getIsModalOpen() {
		return (payload) => {
			return this.isModalOpen[payload.key];
		}
	}
	/**
	 * Get mapping object
	 * @returns Mapping
	 */
	get getSearchTerm() {
		return (payload) => {
			return this.searchTerm[payload.key];
		}
	}
	/**
	 * Get mapping object
	 * @returns Mapping
	 */
	get getSortBy() {
		return (payload) => {
			return this.sortBy[payload.key];
		}
	}
	/**
	 * Get filters of map
	 * @returns Mapping
	 */



	get getAddLink() {
		return (payload) => {
			if (this.mapping[payload.key]) {
				if (this.mapping[payload.key].map) {
					if (this.mapping[payload.key].map['Actions']) {
						return this.mapping[payload.key].map.Actions.addLink;
					}
				}
			}
		}
	}
	get getSorting() {
		return (payload) => {
			if (this.mapping[payload.key]) {
				if (this.mapping[payload.key].map) {
					if (this.mapping[payload.key].map['Sort']) {
						return this.mapping[payload.key].map.Sort;
					}
				}
			}

			return null;
		}
	}

	get getModalRoute() {
		return (payload) => {
			return this.modalRoute[payload.key];
		}
	}
	get getParentID() {
		return (payload) => {
			return this.parentID[payload.key];
		}
	}
	get getInlineSearch() {
		return (payload) => {
			return this.inlineSearch[payload.key];
		}
	}
	get getSortableListChanged() {
		return (payload) => {
			return this.sortableListChanged[payload.key];
		}
	}

	get getFiltersMapping() {
		return (payload) => {
			if (this.mapping[payload.key]) {
				if (this.mapping[payload.key].map) {
					if (this.mapping[payload.key].map.Filters) {
						return this.mapping[payload.key].map.Filters;
					}
				}
			}
			return null;
		}
	}
	get getInitialFiltersMapping() {
		return (payload) => {
			if (this.mapping[payload.key]) {
				if (this.mapping[payload.key].map) {
					if (this.mapping[payload.key].map.InitialFilters) {
						return this.mapping[payload.key].map.InitialFilters
					}
				}
			}
			return null;
		}
	}
}
